module.exports = __webpack_public_path__ + "img/atlas_1000ml.37ddb55e.png";